<script lang="ts">
  export let klass: string = "";
  export let disabled: boolean = false;
</script>

<button type="submit" class="button {klass}" {disabled}>
  <slot />
</button>
